/**
 * R3 / PCI DSS 6.4.3 — keep `eval` out of the payment pages (admin keyed
 * entry loads Accept.js). See apps/customer-app/src/lib/zod-jitless.ts for the
 * full rationale: Zod 4's `new Function("")` JIT probe is a CSP violation on
 * every page load; `jitless: true` takes the same interpreter path Zod falls
 * back to under CSP, minus the violation.
 *
 * Read when each `z.object()` is constructed, so this module MUST be the first
 * import in main.tsx. The Zod copy configured here is the one `@ferro/config`
 * and `@ferro/core` resolve (one hoisted version) — a second Zod copy would
 * need its own call.
 */
import { z } from 'zod';

z.config({ jitless: true });
